export type ImagePlaceholderVariant = "species" | "generic" | "map";

export const imagePlaceholderIcon: Record<ImagePlaceholderVariant, string> = {
  species: "icon:offline-fish",
  generic: "icon:offline-shell",
  map: "icon:offline-map",
};
